import { PageActivityFeatures } from 'constants/pageActivityFeatures';

export type AnalyticsTabId = 'customLanding';

export type AnalyticsTabConfig = {
  id: AnalyticsTabId;
  icon: string;
  feature: string;
  labelKey: string;
};

export const analyticsTabs: AnalyticsTabConfig[] = [
  {
    id: 'customLanding',
    icon: 'ni-home',
    feature: PageActivityFeatures.CUSTOM_LANDING,
    labelKey: 'CustomLandingActivity',
  },
];

export default analyticsTabs;
